import moduleConfig from './module-config';
import netsSelectSubscriber from './nets-select-subscriber';

export default angular
  .module('app.select-subscriber', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsSelectSubscriber', netsSelectSubscriber);
